export default "__VITE_ASSET__iONS2046__"